import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useBreakpoint } from '/fiweb/lib'
import { Button, Heading, Pane, Paragraph, Strong } from 'evergreen-ui'
import { useCustomTheme } from '/fiweb/lib/theme'
import { useAuthContext } from '/~/utils/AuthContext'
import { InvestorInfoCards } from '/~/components/Cards'
import FeaturedCampaignCards from '/~/components/FeaturedCampaignCards'
import { Quotes } from '/fiweb/components/Icons'

const LandingPageInvestor = () => {
  const navigate = useNavigate()
  const { small, medium, large } = useBreakpoint()
  const { user } = useAuthContext()
  const theme = useCustomTheme()

  return (
    <Pane display='flex' flexDirection='column' alignItems='center'>
      <img
        src={`https://folkeinvestmedia.blob.core.windows.net/public/${
          medium ? 'landing-page-investor-mobile' : 'landing-page-investor'
        }.png`}
        alt='Folkeinvest employees talking'
        style={{
          objectFit: medium ? 'fill' : 'contain',
          width: medium ? '100%' : large ? '768px' : '1260px',
          maxWidth: medium ? '680px' : 'none',
          order: medium ? 0 : -1,
          marginBottom: medium ? theme.spacing.m : theme.spacing.xs,
        }}
      />
      <Pane
        position='relative'
        top={medium ? 0 : large ? -340 : -510}
        left={medium ? 0 : large ? -180 : -210}
        width='fit-content'
        display='flex'
        flexDirection='column'
        alignItems={medium ? 'center' : 'none'}
        marginBottom={medium ? theme.spacing.m : large ? -230 : -360}
        order={medium ? -1 : 0}
      >
        <Heading
          width={medium ? '95%' : '100%'}
          color={medium ? theme.colors.fiDark : '#FFFFFF'}
          fontSize={medium ? 52 : large ? 36 : 53}
          lineHeight={large ? '54px' : '71px'}
          marginTop={large ? theme.spacing.xs : theme.spacing.xl}
          marginBottom={theme.spacing.xxs}
          textAlign={medium ? 'center' : 'start'}
        >
          Invester i fremtiden
        </Heading>
        <Paragraph
          color={medium ? theme.colors.text.default : '#FFFFFF'}
          size={large ? 400 : large ? 300 : 500}
          width={medium ? '81%' : large ? 300 : 461}
          marginBottom={large ? theme.spacing.xs : theme.spacing.s}
          textAlign={medium ? 'center' : 'start'}
        >
          Aksjer for alle, invester i det du tror på og skap din suksesshistorie.
        </Paragraph>
        <Button
          width={medium ? '86.67%' : 217}
          appearance='primary'
          size={medium ? 'small' : 'medium'}
          marginBottom={theme.spacing.xs}
          border={medium ? 'none' : '1px solid #FFFFFF'}
          borderColor={medium ? 'none' : '#FFFFFF'}
          onClick={() => navigate(user ? '/kampanjer' : '/innlogging/registrering')}
        >
          Bli en investor
        </Button>
        <Paragraph
          color={medium ? theme.colors.fiDark : '#FFFFFF'}
          fontSize={14}
          lineHeight={medium ? '20px' : '18px'}
          textAlign={medium ? 'center' : 'start'}
          maxWidth={medium ? '81%' : '276px'}
        >
          Folkeinvest AS er godkjent tilrettelegger med konsesjon fra Finanstilsynet.
        </Paragraph>
      </Pane>
      <InvestorInfoCards marginBottom={medium ? theme.spacing.m : theme.spacing.l} />
      <Pane
        display='flex'
        flexDirection={large ? 'column' : 'row'}
        justifyContent='space-between'
        alignItems='center'
        width='100%'
        maxWidth={medium ? '100%' : large ? 700 : 1010}
        marginTop={medium ? -40 : 0}
        marginBottom={large ? theme.spacing.l : 0}
      >
        <Pane maxWidth={large ? '86.67%' : 394} order={large ? 2 : 1} marginTop={medium ? -20 : large ? -80 : -170}>
          <Quotes
            width={large ? '40px' : '52px'}
            height={large ? '50px' : '90px'}
            color={theme.colors.fiGreen}
            style={{ marginTop: large ? theme.spacing.m : 0 }}
          />

          <Paragraph size={400} lineHeight='25.11px' fontFamily='mono' maxWidth={450}>
            Gjennom Folkeinvest.no klarte vi å få inn hele emisjonen på 40 minutter. Folkeinvest.no gjorde det mulig for
            studenter og unge voksne å investere i Sulten på en trygg måte, noe vi ser på som utrolig viktig når vi får
            inn aksjonærer som aldri har investert før. Vi er evig takknemlig for innsatsen, servicen og rådene folka
            bak Folkenivest.no har gitt oss.
          </Paragraph>
          {medium && (
            <Paragraph size={300} color={theme.colors.fiDark70} lineHeight='22px' marginTop={theme.spacing.xs}>
              <Strong fontSize={16} lineHeight='22px'>
                Karen Elene Thorsen
              </Strong>{' '}
              <br /> Daglig leder, Sulten AS
            </Paragraph>
          )}
        </Pane>
        <Pane
          display='flex'
          flexDirection='column'
          alignItems='center'
          width={small ? '100%' : 'fit-content'}
          order={large ? 1 : 2}
        >
          <Pane
            width={small ? '80%' : medium ? '100%' : '65%'}
            height={medium ? 332 : 325}
            backgroundColor={theme.colors.fiGreen10}
            borderTopRightRadius={30}
            borderBottomLeftRadius={30}
            borderBottomRightRadius={5}
            marginTop={theme.spacing.l}
            position='relative'
            alignSelf='flex-end'
            left={small ? 0 : 30}
            marginLeft={small ? 0 : -30}
          />
          <img
            src='https://folkeinvestmedia.blob.core.windows.net/public/karen.png'
            alt='Karen Elene Thorsen, Daglig leder, Sulten AS'
            style={{
              borderRadius: medium ? '5px 5px 30px 5px' : '0px 30px 0px 0px',
              width: small ? '100%' : medium ? '375px' : '456.18px',
              height: medium ? '313.04px' : '325px',
              position: 'relative',
              top: medium ? '-347px' : '-389px',
              marginBottom: '-313.04px',
              objectFit: 'cover',
              objectPosition: 'top',
            }}
          />
          {!medium && (
            <Paragraph
              size={300}
              color={theme.colors.fiDark70}
              lineHeight='22px'
              alignSelf='start'
              textAlign='end'
              width='38%'
              position='relative'
              top={-67}
              left={-10}
            >
              <Strong fontSize={16} lineHeight='22px'>
                Karen Elene Thorsen
              </Strong>{' '}
              <br /> Daglig leder, Sulten AS
            </Paragraph>
          )}
        </Pane>
      </Pane>
      <FeaturedCampaignCards />
    </Pane>
  )
}

export default LandingPageInvestor
